import Util from "./Util.js";
//
import { gsap } from "./Util.js";

class Tab extends Util {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.tipsTab();
    this.infoTab();
  }

  tipsTab() {
    const tipsTab = document.querySelectorAll(".tips-tab");
    tipsTab.forEach((tab) => {
      tab.addEventListener("click", () => {
        tab.classList.toggle("is-active");
      });
    });
  }

  infoTab() {
    const infoTab = document.querySelectorAll(".info-tab .toggle-target span");
    const infoTabDetail = document.querySelectorAll(".info-tab .toggle-detail div");
    infoTab.forEach((tab, i) => {
      tab.addEventListener("click", () => {
        for (let n = 0; n < infoTab.length; n++) {
          infoTab[n].classList.remove("is-active");
          infoTabDetail[n].classList.remove("is-active");
          if (n === i) {
            infoTab[n].classList.add("is-active");
            infoTabDetail[n].classList.add("is-active");
          }
        }
      });
    });
  }
}

export default Tab;
